// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2nGPl","ranges":"BmiRanges_ranges__2Bh3Q"};